/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {useState} from 'react'
import {KTIcon} from '../../../../helpers'
import {CreateAppModal, Dropdown1} from '../../../../partials'
import {useLayout} from '../../../core'
import {useNavigate} from 'react-router-dom'
import {FaPlus} from 'react-icons/fa'
import {useAuth} from '../../../../../app/modules/auth'
import {toast} from 'react-toastify'

interface ToolbarClassicProps {
  claimType: string
  onModalClose: () => void
  onSuccessSubmit?: () => void
}

const ToolbarClassic: React.FC<ToolbarClassicProps> = ({
  claimType,
  onModalClose,
  onSuccessSubmit,
}) => {
  const {config} = useLayout()
  const navigate = useNavigate()
  const {currentUser} = useAuth()
  const providerName = currentUser?.providerName
  const isProviderActive = currentUser?.isActive
  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
  const daterangepickerButtonClass = config.app?.toolbar?.fixed?.desktop
    ? 'btn-light'
    : 'bg-body btn-color-gray-700 btn-active-color-primary'

  const handleDaftarClick = () => {
    // setShowCreateAppModal(true)
    if (isProviderActive) {
      setShowCreateAppModal(true)
    } else {
      toast.error(`Provider ${providerName} is not active`)
    }
  }

  return (
    <div className='d-flex align-items-center gap-2 gap-lg-3'>
      {/* {config.app?.toolbar?.filterButton && (
        <div className='m-0'>
          <a
            href='#'
            className={clsx('btn btn-sm btn-flex fw-bold', daterangepickerButtonClass)}
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
          >
            <KTIcon iconName='filter' className='fs-6 text-muted me-1' />
            Log
          </a>
          <Dropdown1 />
        </div>
      )} */}

      {config.app?.toolbar?.daterangepickerButton && (
        <div
          data-kt-daterangepicker='true'
          data-kt-daterangepicker-opens='left'
          className={clsx(
            'btn btn-sm fw-bold  d-flex align-items-center px-4',
            daterangepickerButtonClass
          )}
        >
          <div className='text-gray-600 fw-bold'>Loading date range...</div>
          <KTIcon iconName='calendar-8' className='fs-1 ms-2 me-0' />
        </div>
      )}

      {config.app?.toolbar?.secondaryButton && (
        <a href='#' className='btn btn-sm btn-flex btn-light fw-bold'>
          Filter
        </a>
      )}

      {config.app?.toolbar?.primaryButton && (
        <a
          href='#'
          onClick={handleDaftarClick}
          className='btn btn-sm fw-bold btn-primary'
          style={{display: 'flex', alignItems: 'center'}}
        >
          <FaPlus size={12} style={{marginRight: '5px'}} /> Daftar
        </a>
      )}
      <CreateAppModal
        show={showCreateAppModal}
        handleClose={() => {
          setShowCreateAppModal(false)
          onModalClose()
        }}
        onSuccessSubmit={onSuccessSubmit}
      />
    </div>
  )
}

export {ToolbarClassic}
